import api from "../services/api";
import billingApi from "@/modules/billing/services/api";

export default {
  namespaced: true,
  actions: {
    getItems({ commit }, payload) {
      return api
        .getItems({ ...payload, expand: "businessGroup" })
        .then((response) => ({
          items: response.data.items,
          totalCount: response.data.count,
        }));
    },
    getOrganizations({ commit }, payload) {
      return api
        .getItems({ ...payload, expand: "businessGroup" })
        .then((response) => ({
          raw: response.data
        }));
    },
    getBilling: async function ({ commit }, id) {
      return await api.getBilling(id).then((response) => response.data);
    },
    getBillingPlan: async function ({ commit }) {
      return await billingApi.getItems().then((response) => response.data);
    },
  },
};
